import React from 'react';
import SectionClosingStockReport from '../SectionClosingStockReport';
import * as greigeStorageApi from '@/services/greigeStorageApi';

const ClosingStockReport = () => {
  return (
    <SectionClosingStockReport
      sectionName="Greige Storage"
      backRoute="/sections/greige-storage"
      fetchClosingStock={greigeStorageApi.getClosingStockReport}
      fetchOperations={greigeStorageApi.getAvailableOperations}
      exportPrefix="greige_storage"
      summaryGroupBy="design"
      showBundleCount={true}
    />
  );
};

export default ClosingStockReport;
